import { useMemo } from 'react';
import { useGetMatchesLazyQuery, useGetMatchesQuery } from './gql/getMatches.generated';
import { Match } from '@Global/apollo/types';

type TUseMatchesProps = {
  first?: number;
  players?: string[];
  tournaments?: string[];
  teams?: string[];
};

export const useMatches = (variables: TUseMatchesProps) => {
  const { data: matchesData } = useGetMatchesQuery({
    variables: {
      first: variables.first,
      players: variables.players,
      tournaments: variables.tournaments,
      teams: variables.teams,
    },
  });

  const matches = useMemo(
    () => matchesData?.matches.edges.map((edge) => edge.node) as Match[],
    [matchesData?.matches.edges],
  );

  return matches;
};

export const useMatchesLazy = (variables: TUseMatchesProps) => {
  const [getMatches, { loading, data }] = useGetMatchesLazyQuery({
    variables: {
      first: variables.first,
      players: variables.players,
      tournaments: variables.tournaments,
      teams: variables.teams,
    },
  });

  const matches = useMemo(() => data?.matches.edges.map((edge) => edge.node) as Match[], [data?.matches.edges]);

  return {
    getMatches,
    matches,
    loading,
  };
};
